import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DomSanitizer , SafeHtml} from "@angular/platform-browser";


@Component({
    selector: 'preview-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class PreviewFormDialogComponent implements OnInit
{
  action: string;
  dialogTitle;
  public editorContent: SafeHtml;
  title;
  active;
  html;
  rules;
  constructor(
    public dialogRef: MatDialogRef<PreviewFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any, private satinaizer: DomSanitizer
  )
  {
    this.editorContent = this.satinaizer.bypassSecurityTrustHtml(data.privacy);
    this.rules = data.rules;
    console.log(this.rules, 'rules');
  }

  ngOnInit()
  {

  }
}

